/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas30Visitor } from '../visitors/IOas30Visitor';
import { Oas30PathItem } from './Oas30PathItem';

/**
 * Constructor.
 * @param {string} path
 * @class
 * @extends Oas30PathItem
 * @author eric.wittmann@gmail.com
 */
export class Oas30CallbackPathItem extends Oas30PathItem {
    public constructor(path : string) {
        super(path);
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasPathItem#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
        viz.visitCallbackPathItem(this);
    }
}
Oas30CallbackPathItem["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30CallbackPathItem";
Oas30CallbackPathItem["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.openapi.models.IOasParameterParent","io.apicurio.datamodels.core.models.common.IServerParent"];




